import React from 'react';
import {
  Wrapper,
  Body,
  Footer,
  WideButtonPrimary,
  WideButtonLink,
  Title,
  BackButton,
} from './Styles';
import { VIEWS } from '../../UpsertAccountModalConstants';
import { Alert } from '../../../CommonComponents/Alert/Alert';
import ConfirmationModal from '../../../CommonComponents/ConfirmationModal';
import { StyledButton as Button } from '../../../CommonComponents/Button';

export default FormComponent => ({
  account,
  setCurrentView,
  onDeleteAccount,
  onSaveAccount,
  setFocusedAccount,
  errors,
  isSavingAccount,
  isDeletingAccount,
  setErrors,
  typeName,
  isFocusedAccountNew,
  isConfirmationModalOpen,
  setIsConfirmationModalOpen,
  isFocusedAccountEditable,
}) => (
  <Wrapper>
    {isFocusedAccountNew && <BackButton onClick={() => setCurrentView(VIEWS.ADD)}>Back</BackButton>}

    <Body>
      <Title>{typeName}</Title>

      {errors.length > 0 && (
        <Alert
          appearance="info"
          message={errors}
          shouldScrollOnUpdate={false}
          onRequestClose={() => setErrors([])}
        />
      )}

      <FormComponent
        isEditable={isFocusedAccountEditable}
        account={account}
        onUpdate={updates =>
          setFocusedAccount({ ...account, ...updates }, { isNew: isFocusedAccountNew })
        }
      />
    </Body>
    {isFocusedAccountEditable && (
      <Footer>
        {!isFocusedAccountNew && (
          <WideButtonLink
            onClick={() => setIsConfirmationModalOpen(true)}
            disabled={isSavingAccount}
            prependIcon="far fa-trash-alt"
          >
            Delete
          </WideButtonLink>
        )}
        <WideButtonPrimary
          disabled={isSavingAccount}
          isLoading={isSavingAccount}
          onClick={() => onSaveAccount(account)}
        >
          Save
        </WideButtonPrimary>
      </Footer>
    )}

    <ConfirmationModal
      isOpen={isConfirmationModalOpen}
      onClose={() => setIsConfirmationModalOpen(false)}
      title="Delete Account?"
      message="Deleting a transaction will permanently remove it from your profile."
      actions={[
        <Button.Secondary
          disabled={isDeletingAccount}
          onClick={() => setIsConfirmationModalOpen(false)}
        >
          No, keep Account
        </Button.Secondary>,
        <Button.Danger
          onClick={() => onDeleteAccount(account)}
          disabled={isDeletingAccount}
          isLoading={isDeletingAccount}
        >
          Yes, delete
        </Button.Danger>,
      ]}
    />
  </Wrapper>
);
